<div class="relative flex flex-1 flex-row">
  <div
    class="absolute bottom-0 left-0 top-0 flex items-center p-1 px-2 text-xl"
  >
    <i class="fa-light fa-magnifying-glass"></i>
  </div>
  <input
    #input
    (input)="onInput(input.value)"
    type="text"
    class="flex-1 rounded-full border py-1 pl-8 pr-4 text-2xl outline-none"
    [placeholder]="placeholder"
  />
</div>
